interface Props extends React.SVGProps<SVGSVGElement> {
  checked?: boolean
}
export function StarIcon({ className, checked, ...rest }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      className={className}
      {...rest}
    >
      <path
        d="M16.0001 23.8039L21.5334 27.1505C22.5468 27.7639 23.7868 26.8572 23.5201 25.7105L22.0534 19.4172L26.9468 15.1772C27.8401 14.4039 27.3601 12.9372 26.1868 12.8439L19.7468 12.2972L17.2268 6.35053C16.7734 5.27053 15.2268 5.27053 14.7734 6.35053L12.2534 12.2839L5.81343 12.8305C4.6401 12.9239 4.1601 14.3905 5.05343 15.1639L9.94676 19.4039L8.4801 25.6972C8.21343 26.8439 9.45343 27.7505 10.4668 27.1372L16.0001 23.8039Z"
        fill={checked ? 'currentColor' : undefined}
        // oxlint-disable-next-line no-negated-condition
        stroke={!checked ? 'currentColor' : undefined}
        // oxlint-disable-next-line no-negated-condition
        strokeWidth={!checked ? '2' : undefined}
      />
    </svg>
  )
}
